(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7074],{

/***/ 29973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

exports.Z = _default;

/***/ }),

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 17074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ FrequentlyAskedQuestions_FrequentlyAskedQuestions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/style.module.scss
var style_module = __webpack_require__(88415);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/index.tsx + 1 modules
var ChildrenContainer = __webpack_require__(38628);
// EXTERNAL MODULE: ./components/CMS/LinkElement/index.tsx
var LinkElement = __webpack_require__(7098);
// EXTERNAL MODULE: ./components/CMS/MarkdownCMSModule/index.tsx
var MarkdownCMSModule = __webpack_require__(8037);
// EXTERNAL MODULE: ./components/CMS/constants.ts
var constants = __webpack_require__(3379);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/CMS/FrequentlyAskedQuestions/FrequentlyAskedQuestions.module.scss
var FrequentlyAskedQuestions_module = __webpack_require__(42549);
var FrequentlyAskedQuestions_module_default = /*#__PURE__*/__webpack_require__.n(FrequentlyAskedQuestions_module);
;// CONCATENATED MODULE: ./components/CMS/FrequentlyAskedQuestions/FrequentlyAskedQuestion.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 








var FrequentlyAskedQuestion = function(param) {
    var data = param.data, _show = param.show, show = _show === void 0 ? false : _show;
    var ref = (0,react.useState)(show), display = ref[0], setDisplay = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer/* default */.Z, {
        className: (FrequentlyAskedQuestions_module_default()).childrenContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()(!display ? (FrequentlyAskedQuestions_module_default()).hide : (FrequentlyAskedQuestions_module_default()).show, (FrequentlyAskedQuestions_module_default()).entry),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return setDisplay(!display);
                    },
                    "aria-expanded": display,
                    "aria-controls": "answer-".concat(data.id),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        className: (FrequentlyAskedQuestions_module_default()).question,
                        children: data.question
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FrequentlyAskedQuestions_module_default()).answer,
                    id: "answer-".concat(data.id),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownCMSModule/* default */.Z, {
                            source: data.answer
                        }),
                        data.button_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkElement/* LinkElement */.E, {
                            link: data.button_URL,
                            linkStyle: data.button_style,
                            linkText: data.button_text,
                            align: constants/* Alignment.Left */.v2.Left
                        })
                    ]
                })
            ]
        }, data.id)
    });
};
/* harmony default export */ var FrequentlyAskedQuestions_FrequentlyAskedQuestion = (FrequentlyAskedQuestion);

;// CONCATENATED MODULE: ./components/CMS/FrequentlyAskedQuestions/FrequentlyAskedQuestions.tsx







var FrequentlyAskedQuestions = function(param) {
    var heading = param.heading, faq_collections = param.faq_collections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer/* default */.Z, {
        className: (FrequentlyAskedQuestions_module_default()).faqContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (style_module_default()).containerMarginS,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h5",
                    className: (FrequentlyAskedQuestions_module_default()).heading,
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FrequentlyAskedQuestions_module_default()).questionList,
                    children: faq_collections && faq_collections.map(function(el) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions_FrequentlyAskedQuestion, {
                            data: el,
                            show: el.showAnswer
                        }, el.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FrequentlyAskedQuestions_FrequentlyAskedQuestions = (FrequentlyAskedQuestions);

;// CONCATENATED MODULE: ./components/CMS/FrequentlyAskedQuestions/index.ts



/***/ }),

/***/ 7098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ LinkElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_utils_useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9800);
/* harmony import */ var _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3379);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282);
/* harmony import */ var _material_ui_icons_ArrowForward__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29973);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99263);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var LinkElement = function(param) {
    var linkText = param.linkText, link = param.link, linkStyle = param.linkStyle, _align = param.align, align = _align === void 0 ? _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__/* .Alignment.Center */ .v2.Center : _align, buttonClassName = param.buttonClassName, trackAction = param.trackAction;
    var track = (0,_app_utils_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: linkStyle === _cmsComponents_constants__WEBPACK_IMPORTED_MODULE_2__/* .LinkStyle.HyperLink */ .uj.HyperLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[align],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: link,
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hyperLink),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: linkText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ArrowForward__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[align],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "contained",
                color: "secondary",
                onClick: function() {
                    return track("Click", {
                        action: trackAction !== null && trackAction !== void 0 ? trackAction : "CMS Button Click",
                        "element text": linkText !== null && linkText !== void 0 ? linkText : "",
                        "element type": "button"
                    });
                },
                href: link,
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button), (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[linkStyle || "Button"], buttonClassName),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkText),
                    children: linkText
                })
            })
        })
    });
};


/***/ }),

/***/ 8037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MarkdownCMSModule; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88415);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30724);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70738);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57231);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var MarkdownCMSModule = function(param) {
    var source = param.source, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_3___default()), {
        renderers: components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        className: className !== null && className !== void 0 ? className : classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().markdown), (_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().markdownContent)),
        escapeHtml: false,
        children: source
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownCMSModule);


/***/ }),

/***/ 70738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29260);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91066);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable react/display-name */ 



var MarkdownRenderer = {
    link: function(props) {
        var href = props.href, children = props.children;
        var shouldUseTargetSelf = /^(https?):\/\//.test(href) ?  true ? href.startsWith(window.location.origin) // In case someone pastes the full URL
         : 0 : /*
         * Anything else should use target="_self". Especially anything that starts with mailto, tel, or javascript
         */ true;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: shouldUseTargetSelf ? "_self" : "_blank",
            rel: "noreferrer noopener",
            children: children
        });
    },
    image: function(props) {
        var src = props.src, title = props.title;
        if (src.match(/\.(jpeg|jpg|gif|png)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: src,
                        style: {
                            display: "block",
                            width: "80%",
                            height: "400px",
                            objectFit: "cover",
                            margin: "0 auto"
                        },
                        alt: "cover image"
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        if (src.match(/\.(mp4|ogg|webm)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        controls: true,
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().videoPlayer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: src
                        })
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownRenderer);


/***/ }),

/***/ 3379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mp": function() { return /* binding */ GridDirection; },
/* harmony export */   "uj": function() { return /* binding */ LinkStyle; },
/* harmony export */   "v2": function() { return /* binding */ Alignment; }
/* harmony export */ });
/* unused harmony export LayoutBackground */
var LinkStyle;
(function(LinkStyle) {
    LinkStyle["Button"] = "Button";
    LinkStyle["HyperLink"] = "HyperLink";
    LinkStyle["MainCta"] = "MainCTA";
})(LinkStyle || (LinkStyle = {}));
var GridDirection;
(function(GridDirection) {
    GridDirection["Row"] = "row";
    GridDirection["RowReverse"] = "row-reverse";
    GridDirection["Column"] = "column";
    GridDirection["ColumnReverse"] = "column-reverse";
})(GridDirection || (GridDirection = {}));
var Alignment;
(function(Alignment) {
    Alignment["Center"] = "Center";
    Alignment["Left"] = "Left";
    Alignment["Right"] = "Right";
})(Alignment || (Alignment = {}));
var LayoutBackground;
(function(LayoutBackground) {
    LayoutBackground["Dark"] = "Dark";
    LayoutBackground["Light"] = "Light";
})(LayoutBackground || (LayoutBackground = {}));


/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ }),

/***/ 42549:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"FrequentlyAskedQuestions_faqContainer__wA_Ep","heading":"FrequentlyAskedQuestions_heading__6wLXn","questionList":"FrequentlyAskedQuestions_questionList__P_L_A","childrenContainer":"FrequentlyAskedQuestions_childrenContainer__I7W9R","entry":"FrequentlyAskedQuestions_entry__sD_it","question":"FrequentlyAskedQuestions_question__kh_BG","answer":"FrequentlyAskedQuestions_answer__yVebU","hide":"FrequentlyAskedQuestions_hide__Ciiok","show":"FrequentlyAskedQuestions_show__46suU"};

/***/ }),

/***/ 99263:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Rcefn","hyperLink":"style_hyperLink__g4rtX","Center":"style_Center__DL8Bq","Left":"style_Left__zB0JX","Right":"style_Right__AjXfw","button":"style_button__gvJJG","MainCTA":"style_MainCTA__91BON","linkText":"style_linkText__cHMTR"};

/***/ }),

/***/ 57231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__ACijO"};

/***/ }),

/***/ 91066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageAndLinkTitle":"style_imageAndLinkTitle____viQ","videoPlayer":"style_videoPlayer__ZQkbF"};

/***/ }),

/***/ 88415:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerMarginL":"style_containerMarginL__Xin_m","containerMarginM":"style_containerMarginM__gcEkK","containerMarginS":"style_containerMarginS__uOEYv","containerPaddingS":"style_containerPaddingS__F37JV","markdownContent":"style_markdownContent__x1pNa"};

/***/ })

}]);